import React, { ReactNode, Suspense } from 'react';
import { useSidePanel, showSidePanel } from '../../../../features/SidePanel';
import { Link } from './Link';
import { IconMore } from './IconMore';
import { Name } from './Name';

export function FlyOutToggle({
  avatar,
  name,
}: {
  avatar: ReactNode;
  name: ReactNode;
}) {
  const [, sidePanelDispatch] = useSidePanel();

  return (
    <Link
      href="#"
      onClick={e => {
        e.preventDefault();
        sidePanelDispatch(showSidePanel());
      }}
      data-testid="navigation-flyout-toggle"
    >
      <IconMore />
      <Suspense fallback={null}>
        {avatar} <Name>{name}</Name>
      </Suspense>
    </Link>
  );
}
